import React, { FunctionComponent, useContext } from "react";
import {PageContext, PageContextProps} from "/src/contexts/Page";
import { Box, Typography, Link } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles"
import { useTranslation, Trans } from "react-i18next";
import { links } from "/src/domain/shared/links";
const protocolBanner = require("/src/assets/empty_protocol.svg");

export const EmptyProtocolBanner: FunctionComponent = ({

}) => {
    const { t } = useTranslation();
    const classes = useStyles();

    const {pageConfig} = useContext(PageContext) as PageContextProps;

    return <Box className={classes.bannerContainer}>
        <img src={protocolBanner} className={classes.banner} alt="protocol banner"/>
        <Typography className={classes.description}>
            <Trans 
                i18nKey={"betaProtocolDescription"}
                components={[
                    <Link href={links.profileLink}>
                    </Link>
                ]}
            />
        </Typography>
    </Box>
}

const useStyles = makeStyles((muiTheme) => ({
    bannerContainer: {
        margin: "1.5rem 1.5rem 0",
        textAlign: "center"
    },
    banner: {
        width: "100%",
        maxWidth: "30rem"
    },
    description: {
        marginTop: "1.5rem",
        whiteSpace: "pre-line",
        color: muiTheme.palette.primary.main
    }
}))